export default "__VITE_ASSET__83518a60__"